// ** Icons Import
import {
  Home,
  Circle,
  User,
  Users,
  Box,
  Bell,
  Flag,
  DollarSign,
  Settings,
  TrendingUp,
  Play,
  ArrowLeft
} from 'react-feather';

// ** Icons Import

export default [
  {
    id: 'DASHBOARD',
    title: 'Dashboard',
    icon: <Home size={20} />,
    // badge: 'light-warning',
    // badgeText: '0',
    navLink: '/dashboard'
  },
  {
    id: 'USERS',
    title: 'User',
    icon: <User size={20} />,
    navLink: '/users/list'
  },
  {
    id: 'ADMINS',
    title: 'Administradores',
    icon: <Users size={20} />,
    navLink: '/administrators/list'
  },
  {
    id: 'ROADS',
    title: 'Caminos',
    icon: <Box size={20} />,
    children: [
      {
        id: 'activities',
        title: 'Actividades',
        icon: <Circle size={12} />,
        navLink: '/roads/activities/list'
      },
      {
        id: 'episodes',
        title: 'Episodios',
        icon: <Circle size={12} />,
        navLink: '/roads/episodes/list'
      },
      {
        id: 'roads',
        title: 'Caminos',
        icon: <Circle size={12} />,
        navLink: '/roads/list'
      }
    ]
  },
  {
    id: 'RANKING',
    title: 'Ranking',
    icon: <TrendingUp size={20} />,
    children: [
      {
        id: 'roads',
        title: 'Caminos',
        icon: <Circle size={12} />,
        navLink: '/ranking/roads'
      },
      {
        id: 'emotions',
        title: 'Emociones',
        icon: <Circle size={12} />,
        navLink: '/ranking/emotions'
      }
    ]
  },
  {
    id: 'NOTIFICATION',
    title: 'Notificaciones',
    icon: <Bell />,
    children: [
      {
        id: 'deliberate',
        title: 'Deliberados',
        icon: <Circle />,
        navLink: '/notifications/deliberate'
      },
      {
        id: 'scheduled',
        title: 'Programadas',
        icon: <Circle />,
        navLink: '/notifications/scheduled'
      }
    ]
  },
  {
    id: 'ACHIEVEMENTS',
    title: 'Mis Logros',
    icon: <Flag size={20} />,
    navLink: '/my-achievements'
  },
  {
    id: 'INCOME',
    title: 'Ingresos',
    icon: <DollarSign size={20} />,
    navLink: '/income'
  },
  {
    id: 'AUDIOHISTORY',
    title: 'Historial de audios',
    icon: <Play size={20} />,
    navLink: '/audioHistory'
  },
  {
    id: 'FEEDBACK',
    title: 'Feedback',
    icon: <ArrowLeft size={20} />,
    navLink: '/feedback'
  },
  {
    id: 'CONFIG',
    title: 'Configuracion',
    icon: <Settings size={20} />,
    children: [
      {
        id: 'general',
        title: 'General',
        icon: <Circle size={12} />,
        navLink: '/settings/general'
      },
      {
        id: 'phrase-design',
        title: 'Diseño Frases',
        icon: <Circle size={12} />,
        navLink: '/settings/phrase-design'
      }
    ]
  }
];
